var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckingactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.02563C0 3.60736 3.58172 0.0256348 8 0.0256348H36C40.4183 0.0256348 44 3.60736 44 8.02563V36.0256C44 40.4439 40.4183 44.0256 36 44.0256H8C3.58172 44.0256 0 40.4439 0 36.0256V8.02563Z",
    fill: "#516F90"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_10300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.0256L15.723 26.4248C15.4987 26.2762 15.3221 26.0853 15.1932 25.852C15.0644 25.6188 15 25.3733 15 25.1156V14.6621C15 14.2048 15.175 13.8177 15.525 13.5009C15.875 13.184 16.3026 13.0256 16.8077 13.0256H28.1923C28.6974 13.0256 29.125 13.184 29.475 13.5009C29.825 13.8177 30 14.2048 30 14.6621V25.1156C30 25.3733 29.9356 25.6188 29.8068 25.852C29.6779 26.0853 29.5013 26.2762 29.277 26.4248L22.5 31.0256ZM22.5 29.3197L28.375 25.3333C28.4135 25.3042 28.4439 25.2708 28.4663 25.2331C28.4888 25.1954 28.5 25.1533 28.5 25.107V14.6621C28.5 14.5924 28.4679 14.5285 28.4038 14.4706C28.3398 14.4125 28.2692 14.3835 28.1923 14.3835H16.8077C16.7307 14.3835 16.6603 14.4125 16.5963 14.4706C16.5321 14.5285 16.5 14.5924 16.5 14.6621V25.107C16.5 25.1533 16.5113 25.1954 16.5338 25.2331C16.5561 25.2708 16.5865 25.3042 16.625 25.3333L22.5 29.3197ZM21.45 24.0275L26.7538 19.2264L25.7 18.2447L21.45 22.0919L19.3308 20.1735L18.2463 21.1274L21.45 24.0275ZM22.5 14.3835H16.5H28.5H22.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_10300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13.0256)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckingactive);
export default __webpack_public_path__ + "static/media/checkingactive.0c31b3c76f71711a1df9c031bd756903.svg";
export { ForwardRef as ReactComponent };